<template>  
  <div class="blog__categories-wrapper">
    <div class="blog__categories">
      <ul class="blog__categories-links">
        <li v-for="blog in categoryLinks.blogs" :key="blog.blogTitle">
          <a class="link tab-link" :href="blog.blogUrl" :class="{ 'tab-link--active' : blog.blogUrl === currentPage }">
            <span class="button__content">{{ blog.blogTitle }}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { elementAtTop } from '@/scripts/helpers/elementAtTop.js'

export default {
  name: 'BlogCategoryLinks',
  components: {},
  data () {
    return {
      currentPage: window.location.pathname
    }
  },
  props: {
    categoryLinks: {
      type: Object
    }
  },
  mounted () {
    window.addEventListener('scroll', function (e) {
      elementAtTop('.blog__categories')
    })
  }
}
</script>

<style scoped lang="scss">
  .blog__categories {
    &-links {
      padding: 0;
      margin: 0;
      display: flex;
      li {
        padding: 0 20px;
        &:first-child {
          padding-left: 0;
        }
        &:last-child {
          padding-right: 0;
        }
      }
    }
  }
</style>
